import {
  createValidation,
  validatorRequired,
  validatorZip,
} from '../../utils/formValidators';

import { fromRegisterEntityContactFields } from '../../constants/formRegister';

export default createValidation([
  {
    name: fromRegisterEntityContactFields.ADDRESS,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: fromRegisterEntityContactFields.CITY,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: fromRegisterEntityContactFields.COUNTRY,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: fromRegisterEntityContactFields.ZIP_CODE,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorZip()(field),
    ],
  },
]);
